import axios from 'axios'
import { useAuthStore } from '../store/auth'

const api = axios.create({
  baseURL: '/api',
  timeout: 10000
})

// 请求拦截器
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().logout()
      window.location.href = '/login'
    }
    return Promise.reject(error.response?.data || error)
  }
)

export const authApi = {
  login: (data: { username: string; password: string; role: string }) =>
    api.post('/auth/login', data),

  register: (data: { username: string; password: string; name: string; role: string }) =>
    api.post('/auth/register', data)
}

export const assignmentApi = {
  // 教师相关
  create: (data: any) => api.post('/assignments', data),
  list: (params?: any) => api.get('/assignments', { params }),
  delete: (id: number) => api.delete(`/assignments/${id}`),

  // 学生相关
  submit: (id: number, data: FormData) =>
    api.post(`/assignments/${id}/submit`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  // 下载文件
  downloadTemplate: (id: number) =>
    api.get(`/assignments/${id}/template`, { responseType: 'blob' }),

  // 评分
  grade: (submissionId: number) => api.post(`/submissions/${submissionId}/grade`)
}

export const submissionApi = {
  list: (params?: any) => api.get('/submissions', { params }),
  get: (id: number) => api.get(`/submissions/${id}`)
}

export default api
